
import { MOMENT_TIME } from '../../momenttime'
import { FORMAT } from '../core/format'
import { PAIPAN } from '../core/paipan'
import * as consts from '../base/consts'
import { UTILS } from '../../utils'
import { SHEN_SHA } from '../core/shensha'
import { HE_HUA_CHONG} from '../core/hehuachong'
import { WUXING } from '../core/wuxing'
import { RENYUANSILING } from '../core/renyuansiling'
import { SANHUAN } from '../core/sanhuan'
import { NAYIN } from '../core/nayin'
import { KONGWANG } from '../core/kongwang'

var FATE_DATA_MANAGER = {
    // 获取八字命盘:命盘信息+运盘信息
    getDetailFateDataByData(data, from) {

        // 特殊处理:Fix:::分享页面type为4,new里面字段不足；
        data.unknown = data.unknown ? data.unknown : 0;
        data.real_time = data.real_time ? data.real_time : 0;

        // 命盘信息
        var starttime = data.rt == 0 && data.unknown == 0 ? data.realDate : data.birthdayDate;
            starttime = MOMENT_TIME.getUnixTimeByTimeStr(starttime);
        var baziData = PAIPAN.GetInfo(data.sex, starttime, data.zwzs),
            tiangan = baziData.tg, rigan = tiangan[2];
            // console.error('getDetailFateDataByData----', baziData)

        var fateListData = this.getFateListDataByData(data.unknown, baziData, starttime, from);
        var fortuneData = this.getFortuneListByArr(baziData.big_info, rigan, from, baziData.tg, baziData.dz);
        var detailInfoData = this.getDetailInfomationByData(data, baziData);

        // 把命盘的基础信息，和命盘的四柱八字信息返回
        var result = {
            // 顶部标题栏数据
            "fateInfo": Object.assign(baziData, { "name": data.f_name, "sex": data.sex, "zwzs": data.zwzs, "rigan": rigan }),
            // 命盘数据
            "fateListData": fateListData,
            // 大运名称
            "fortuneTitle": fortuneData.title,
            // 大运列表数据
            "fortuneListData": fortuneData.arr,
            "detailInfo": detailInfoData
        }
        return result;
    },
    /**
     * 更新八字命盘信息:编辑页联动修改
     * @param {输入表单数据} data 
     */
    updateDetailFateDataByData(data) {
        var starttime = data.real_time != 0 && data.unknown == 0 ? data.real_time : data.birthday;
            starttime = MOMENT_TIME.getUnixTimeByTimeStr(starttime);
        var baziData = PAIPAN.GetInfo(data.sex, starttime, data.zwzs);

        var fateListData = this.getFateListDataByData(data.unknown, baziData, starttime, 'detail');
        return fateListData;
    },
    // 获取命盘信息
    getFateListDataByData(unknown, baziData, starttime, from) {
        // 生日年月日时信息
        var time = MOMENT_TIME.getTimeArrayByTimeStamp(starttime * 1000),
        year = time[0], month = time[1], day = time[2], hour = time[3], minute = time[4];

        var solarTime = PAIPAN.Solar2Lunar(year, month, day);
        console.log('getFateListDataByData-----', solarTime, baziData)
        var runStr = solarTime.r == 1 ? "闰" : "";
        var resultArr = [], tiangan = baziData.tg, dizhi = baziData.dz, rigan = tiangan[2];
        // 四柱数据:年柱
        var yearData = {
            id: 'year',
            key: 'year_'+year,
            title: from == 'detail' ? [year + '年', FORMAT.getChineseWordByNumber('year', solarTime.y)] : [year + '年'],
            gan: FORMAT.getTianGanWordDataByIndex(tiangan[0]),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[0], rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[0]),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[0], rigan),
            ganzhi: FORMAT.getTianGanByIndex(tiangan[0]) + FORMAT.getDiZhiByIndex(dizhi[0]),
            nayin: NAYIN.getNaYinByGanZhi(tiangan[0], dizhi[0]).split(''),
            riKong: KONGWANG.getNianKongByNianRiZhu(tiangan[2]+''+dizhi[2], dizhi[0])
        }
        // 四柱数据:月柱
        var monthData = {
            id: 'month',
            key: 'month_'+month,
            title: from == 'detail' ? [month + '月', runStr + FORMAT.getChineseWordByNumber('month', solarTime.m)] : [month + '月'],
            gan: FORMAT.getTianGanWordDataByIndex(tiangan[1]),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[1], rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[1]),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[1], rigan),
            ganzhi: FORMAT.getTianGanByIndex(tiangan[1]) + FORMAT.getDiZhiByIndex(dizhi[1]),
            nayin: NAYIN.getNaYinByGanZhi(tiangan[1], dizhi[1]).split(''),
            nianKong: KONGWANG.getNianKongByNianRiZhu(tiangan[0]+''+dizhi[0], dizhi[1]),
            riKong: KONGWANG.getNianKongByNianRiZhu(tiangan[2]+''+dizhi[2], dizhi[1])
        }
        // 四柱数据:日柱
        var dayData = {
            id: 'day',
            key: 'day_'+day,
            title: from == 'detail' ? [day + '日', FORMAT.getChineseWordByNumber('day', solarTime.d)] : [day + '日'],
            gan: FORMAT.getTianGanWordDataByIndex(tiangan[2]),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[2], rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[2]),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[2], rigan),
            ganzhi: FORMAT.getTianGanByIndex(tiangan[2]) + FORMAT.getDiZhiByIndex(dizhi[2]),
            nayin: NAYIN.getNaYinByGanZhi(tiangan[2], dizhi[2]).split(''),
            nianKong: KONGWANG.getNianKongByNianRiZhu(tiangan[0]+''+dizhi[0], dizhi[2]),
        }
        // 四柱数据:时柱
        var hourData = {};
        if(unknown == 1){
            hourData = {
                id: 'hour',
                key: 'hour_0000',
                title: from == 'detail' ? ['时', '辰'] : ['不详'],
                gan: {text: '不', propXingEn: 'no'},
                ganCang: [],
                zhi: {text: '详', propXingEn: 'no'},
                zhiCang: [],
                ganzhi: '不详'
            }
        }else{
            hourData = {
                id: 'hour',
                key: 'hour_'+hour,
                title: from == 'detail' ? [hour + '时' + minute + '分', FORMAT.getShiChenByNumber(hour)] : [hour + '时' + minute + '分'],
                gan: FORMAT.getTianGanWordDataByIndex(tiangan[3]),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', tiangan[3], rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(dizhi[3]),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', dizhi[3], rigan),
                ganzhi: FORMAT.getTianGanByIndex(tiangan[3]) + FORMAT.getDiZhiByIndex(dizhi[3]),
                nayin: NAYIN.getNaYinByGanZhi(tiangan[3], dizhi[3]).split(''),
                nianKong: KONGWANG.getNianKongByNianRiZhu(tiangan[0]+''+dizhi[0], dizhi[3]),
                riKong: KONGWANG.getNianKongByNianRiZhu(tiangan[2]+''+dizhi[2], dizhi[3])
            }
        }
        resultArr.push(yearData);
        resultArr.push(monthData);
        resultArr.push(dayData);
        resultArr.push(hourData);

        // console.log("getFateListDataByData------", time, solarTime)
        // console.log("getFateListDataByData------", year, month, day, hour);
        console.log("getFateListDataByData------", resultArr);
        return resultArr;
    },
    // 获取命盘资料信息
    getDetailInfomationByData(data, baziData){
        // console.log('getDetailInfomationByData------', data, baziData)
        var niangan = baziData.tg[0], nianzhi = baziData.dz[0];
        
        // 命主资料
        var baseInfo = (niangan%2 == 0 ? '阳' : '阴') + (data.sex == 0 ? '男' : '女') + ' ';
            baseInfo = baseInfo + '生肖' + FORMAT.getShengXiaoByNianZhi(nianzhi) + ' ';
            baseInfo = baseInfo + '虚岁' + FORMAT.getXuYearsOldByYear(data.birthday);
        
            // 阳历生日+农历生日
        var time = MOMENT_TIME.getTimeArrayByTimeStamp(data.birthday * 1000),
            y = time[0], m = UTILS.getTimeStrByInt(time[1]), d = UTILS.getTimeStrByInt(time[2]), hh = UTILS.getTimeStrByInt(time[3]), mm = UTILS.getTimeStrByInt(time[4]),
            solarTime = y + '年' + m + '月' + d + '日 ' + hh + ':' + mm + ' ' + FORMAT.getShiChenByNumber(parseInt(hh));
        
            // 农历生日
        var lunarData = PAIPAN.Solar2Lunar(y, time[1], time[2]),
            lunarTime = FORMAT.getChineseWordByNumber('year', lunarData.y) + (lunarData.r ? '闰' : '') + FORMAT.getChineseWordByNumber('month', lunarData.m) + FORMAT.getChineseWordByNumber('day', lunarData.d)
            console.log('lunarData-----', lunarData);      
        // 真太阳时
        var realSunTime = '';
        if(data.real_time){
            var real_time = data.realDate == '' ? 0 : MOMENT_TIME.getUnixTimeByTimeStr(data.realDate),
                sun_time = real_time == 0 ? [] : MOMENT_TIME.getTimeArrayByTimeStamp(real_time * 1000);
            if(sun_time.length > 0){
                var y = time[0], m = UTILS.getTimeStrByInt(sun_time[1]), d = UTILS.getTimeStrByInt(sun_time[2]), hh = UTILS.getTimeStrByInt(sun_time[3]), mm = UTILS.getTimeStrByInt(sun_time[4]),
                realSunTime = y + '年' + m + '月' + d + '日 ' + hh + ':' + mm;
            }
        }

        // 出生地区
        var locatData = !data.location || data.location == '' ? {} : JSON.parse(data.location),
            locatStr = !data.location || data.location == '' ? '' : locatData.province + locatData.city + locatData.name;
        // 出生时节
        var birthJQArr = [];
            birthJQArr.push([baziData.jieqi.beg.name, FORMAT.getDifferentialDayByNum(time, baziData.jieqi.beg.time)])
            birthJQArr.push([baziData.jieqi.mid.name, FORMAT.getDifferentialDayByNum(time, baziData.jieqi.mid.time)])
            birthJQArr.push([baziData.jieqi.end.name, FORMAT.getDifferentialDayByNum(time, baziData.jieqi.end.time)])
        // 节气时间
        var timeJQArr = [];
            timeJQArr.push(baziData.jieqi.beg.name+':'+UTILS.getJieQiTimeStrByTimeArr(baziData.jieqi.beg.time));
            timeJQArr.push(baziData.jieqi.mid.name+':'+UTILS.getJieQiTimeStrByTimeArr(baziData.jieqi.mid.time));
            timeJQArr.push(baziData.jieqi.end.name+':'+UTILS.getJieQiTimeStrByTimeArr(baziData.jieqi.end.time));
        // 大运开始
        var dayunStrArr = [];
        var startDes = baziData.start_ymd ? baziData.start_ymd.y + "年" + baziData.start_ymd.m + "个月" + baziData.start_ymd.d + "天" + baziData.start_ymd.h + "时后起运" : '';
            dayunStrArr.push(startDes);
            dayunStrArr.push(UTILS.getDaYunStartTimeStrByData(baziData.begtime));
        // 交大运
        var startDes2 = baziData.start_y_tg ? '逢'+FORMAT.getTianGanByIndex(baziData.start_y_tg[0])+FORMAT.getTianGanByIndex(baziData.start_y_tg[1])+'年' : '';
            startDes2 = baziData.last_jq ? startDes2+' '+baziData.last_jq.name+'后'+baziData.last_jq.diff+'天交大运' : '';
            dayunStrArr.push(startDes2);
        // 命局强弱
        var strongStr = data.strong;
        // 命局格局
        var situationStr = data.situation;

        // 人元司令
        var ryslData = RENYUANSILING.getRyslByYueZhiJieqi(baziData.dz[1], birthJQArr[0]);
        // 命宫胎元
        var mingGong = SANHUAN.getMingGongByYueShi(baziData.tg[1], baziData.dz[1], baziData.dz[3])
        var shenGong = SANHUAN.getShenGongByYueShi(baziData.tg[1], baziData.dz[1], baziData.dz[3])
        var taiYuan = SANHUAN.getTaiYuanByYueZhu(baziData.tg[1], baziData.dz[1]);

        var resultData = {
            baseInfo: baseInfo,
            solarTime: solarTime,
            lunarTime: lunarTime,
            realSunTime: realSunTime,
            locatStr: locatStr,
            renyuansiling: ryslData,
            minggong: mingGong,
            shengong: shenGong,
            taiyuan: taiYuan,
            birthJQArr: birthJQArr,
            timeJQArr: timeJQArr,
            dayunStrArr: dayunStrArr,
            strongStr: strongStr,
            situationStr: situationStr
        };
        console.log('getDetailInfomationByData------', data, baziData, resultData)
        return resultData;
    },
    // 获取运盘大运信息
    getFortuneListByArr(bigArr, rigan, from, tg, dz) {
        var resultTitle = "", resultArr = [];
        var nowTime = MOMENT_TIME.getTimeArrayByTimeStamp(),
            lunarTime = PAIPAN.Solar2Lunar(nowTime[0], nowTime[1], nowTime[2]);
        _.forEach(bigArr, (element, index) => {
            var data = FATE_DATA_MANAGER.getFortuneDaYunData(element, index, rigan, from, tg, dz);
            // 是否有批盘的状态:小绿点:迷你命盘
            if(from == 'mini') {
                data.commentEdited = false; data.commented = false;
            }
            try {
                var nowSec = MOMENT_TIME.getTimeStampByNow(); // unix seconds
                // 立春时间：获取该年份立春的儒略日并转为公历时间数组
                var springJd = PAIPAN.getFirstJq(element.y);
                var springArr = PAIPAN.Julian2Solar(springJd);
                var springStr = PAIPAN.formatYearNum(springArr[0]) + '-' + UTILS.getTimeStrByInt(springArr[1]) + '-' + UTILS.getTimeStrByInt(springArr[2]) + ' ' + UTILS.getTimeStrByInt(springArr[3]) + ':' + UTILS.getTimeStrByInt(springArr[4]) + ':' + UTILS.getTimeStrByInt(springArr[5]);
                var springSec = MOMENT_TIME.getUnixTimeByTimeStr(springStr);

                // 下一年立春
                var nextSpringJd = PAIPAN.getFirstJq(bigArr[index+1].y);
                var nextSpringArr = PAIPAN.Julian2Solar(nextSpringJd);
                var nextSpringStr = PAIPAN.formatYearNum(nextSpringArr[0]) + '-' + UTILS.getTimeStrByInt(nextSpringArr[1]) + '-' + UTILS.getTimeStrByInt(nextSpringArr[2]) + ' ' + UTILS.getTimeStrByInt(nextSpringArr[3]) + ':' + UTILS.getTimeStrByInt(nextSpringArr[4]) + ':' + UTILS.getTimeStrByInt(nextSpringArr[5]);
                var nextSpringSec = MOMENT_TIME.getUnixTimeByTimeStr(nextSpringStr);

                data.current = (nowSec >= springSec && nowSec < nextSpringSec) ? true : false;
            } catch (e) {
                // 回退到原有判断，避免异常影响页面
                data.current = lunarTime.y >= element.y && lunarTime.y <= element.y+9 ? true : false;
            }
            // 当前大运
            resultArr.push(data);
        });
        // 只取10个大运+起运前
        resultArr.splice(11);
        
        console.log("getFortuneListByArr----", resultTitle, resultArr);
        var result = {
            'title': resultTitle,
            'arr': resultArr
        }
        return result;
    },
    // 获取大运:大运信息
    getFortuneDaYunData(data, index, rigan, from, tg, dz) {
        var resultData = {
            id: data.y,
            index: index,
            year: data.y,
            ganzhi: FORMAT.getTianGanByIndex(data.tg) + FORMAT.getDiZhiByIndex(data.dz),
            type: 'dayun',
            before: data.before ? true : false,
            key: 'big'+index,
            title: from == 'detail' ? [data.y, data.age + '岁'] : [data.y + '/' + data.age],
            gan: FORMAT.getTianGanWordDataByIndex(data.tg),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', data.tg, rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(data.dz),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', data.dz, rigan),
            nayin: NAYIN.getNaYinByGanZhi(data.tg, data.dz).split(''),
            nianKong: KONGWANG.getNianKongByNianRiZhu(tg[0]+''+dz[0], data.dz),
            riKong: KONGWANG.getNianKongByNianRiZhu(tg[2]+''+dz[2], data.dz),
            choosed: false
        };
        return resultData;
    },
    // 获取八字运盘:流年信息
    getFortuneLiuNianDataByYear(fateInfo, yearData, from) {
        console.log('getFortuneLiuNianDataByYear-----', fateInfo, yearData, from);
        var arr = yearData.dayunBefore ? PAIPAN.getLiuNianBefore(fateInfo.birth_beg[0], fateInfo.birth_beg[1]) : PAIPAN.getLiuNian(yearData.yearNum);
        var nowTime = MOMENT_TIME.getTimeArrayByTimeStamp(),
            lunarTime = PAIPAN.Solar2Lunar(nowTime[0], nowTime[1], nowTime[2]);
        var resultArr = [];
        _.forEach(arr, (element, index) => {
            var data = FATE_DATA_MANAGER.getFortuneLiuNianData(fateInfo, element, index, yearData.startAge, from);
            // 是否有批盘的状态:小绿点:迷你命盘
            if(from == 'mini') {
                data.commentEdited = false; data.commented = false;
            }
            // 当前流年: 使用公历当前时间与该流年所在公历年的立春时间比较判断
            try {
                var nowSec = MOMENT_TIME.getTimeStampByNow(); // unix seconds
                // 立春时间：获取该年份立春的儒略日并转为公历时间数组
                var springJd = PAIPAN.getFirstJq(element.y);
                var springArr = PAIPAN.Julian2Solar(springJd);
                var springStr = PAIPAN.formatYearNum(springArr[0]) + '-' + UTILS.getTimeStrByInt(springArr[1]) + '-' + UTILS.getTimeStrByInt(springArr[2]) + ' ' + UTILS.getTimeStrByInt(springArr[3]) + ':' + UTILS.getTimeStrByInt(springArr[4]) + ':' + UTILS.getTimeStrByInt(springArr[5]);
                var springSec = MOMENT_TIME.getUnixTimeByTimeStr(springStr);

                // 下一年立春
                var nextSpringJd = PAIPAN.getFirstJq(element.y + 1);
                var nextSpringArr = PAIPAN.Julian2Solar(nextSpringJd);
                var nextSpringStr = PAIPAN.formatYearNum(nextSpringArr[0]) + '-' + UTILS.getTimeStrByInt(nextSpringArr[1]) + '-' + UTILS.getTimeStrByInt(nextSpringArr[2]) + ' ' + UTILS.getTimeStrByInt(nextSpringArr[3]) + ':' + UTILS.getTimeStrByInt(nextSpringArr[4]) + ':' + UTILS.getTimeStrByInt(nextSpringArr[5]);
                var nextSpringSec = MOMENT_TIME.getUnixTimeByTimeStr(nextSpringStr);

                data.current = (nowSec >= springSec && nowSec < nextSpringSec) ? true : false;
            } catch (e) {
                // 回退到原有判断，避免异常影响页面
                data.current = lunarTime.y == element.y ? true : false;
            }
            resultArr.push(data);
        });
        console.log("getFortuneLiuNianDataByYear----", resultArr);
        return resultArr;
    },
    // 获取流年数据
    getFortuneLiuNianData(fateInfo, data, index, startAge, from) {
        var resultData = {
            id: (data.y + (index + 1) * 10000),
            index: index,
            year: data.y,
            ganzhi: FORMAT.getTianGanByIndex(data['g']) + FORMAT.getDiZhiByIndex(data['z']),
            type: 'liunian',
            key: data.y.toString(),
            title: from == 'detail' ? [data.y, (startAge + index) + '岁'] : [data.y + '/' + (startAge + index)],
            gan: FORMAT.getTianGanWordDataByIndex(data.g),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', data.g, fateInfo.rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(data.z),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', data.z, fateInfo.rigan),
            nayin: NAYIN.getNaYinByGanZhi(data.g, data.z).split(''),
            nianKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[0]+''+fateInfo.dz[0], data.z) : false,
            riKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[2]+''+fateInfo.dz[2], data.z) : false,
            choosed: false
        }
        return resultData;
    },
    // 获取八字运盘:流月信息
    getFortuneLiuYueDataByYear(fateInfo, yearNum, from) {
        var arr = PAIPAN.getLiuYue(yearNum);
        var nowTime = MOMENT_TIME.getTimeStampByNow();
        var resultArr = [];
        _.forEach(arr, (element, index) => {
            var data = FATE_DATA_MANAGER.getFortuneLiuYueData(fateInfo, element, index, from);
            var temp1 = '', temp2 = '', month1, month2;
            // 当前月
            temp1 = UTILS.getYmdHmsTimeStrByArr([arr[index].y, arr[index].m, arr[index].d]);
            month1 = MOMENT_TIME.getUnixTimeByTimeStr(temp1);
            // 下一月
            if(index < arr.length-1) {
                temp2 = UTILS.getYmdHmsTimeStrByArr([arr[index+1].y, arr[index+1].m, arr[index+1].d]);
            }else {
                var tempArr = PAIPAN.getLiuRi(arr[index].begtime, arr[index].endtime),
                    lastDay = tempArr && tempArr.length > 0 ? tempArr[tempArr.length-1] : undefined;
                temp2 = lastDay ?  UTILS.getYmdHmsTimeStrByArr([lastDay.y, lastDay.m, lastDay.d]) : "";
            }
            month2 = MOMENT_TIME.getUnixTimeByTimeStr(temp2);
            // 当前流月
            data.current = month1 <= nowTime && nowTime <= month2 ? true : false;
            resultArr.push(data);
        })
        // console.log("getFortuneLiuYueDataByYear----", yearNum, resultArr);
        return resultArr;
    },
    // 获取流月数据
    getFortuneLiuYueData(fateInfo, data, index, from) {
        var resultData = {
            id: (data.d + (index + 1) * 100 + index),
            index: index,
            time: [data.begtime, data.endtime],
            ganzhi: data.msg,
            type: 'liuyue',
            key: 'yue_'+index,
            title: from == 'detail' ? [(data.m + '-' + data.d), FORMAT.getMonthFestivalByIndex(index)] : [data.m + '-' + data.d],
            gan: FORMAT.getTianGanWordDataByIndex(data.g),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', data.g, fateInfo.rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(data.z),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', data.z, fateInfo.rigan),
            nayin: NAYIN.getNaYinByGanZhi(data.g, data.z).split(''),
            nianKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[0]+''+fateInfo.dz[0], data.z) : false,
            riKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[2]+''+fateInfo.dz[2], data.z) : false,
            choosed: false
        }
        return resultData;
    },
    // 获取八字运盘:流日信息
    getFortuneLiuRiDataByYear(fateInfo, yueArr) {
        var arr = PAIPAN.getLiuRi(yueArr[0], yueArr[1]);
        var nowTime = MOMENT_TIME.getTimeArrayByTimeStamp();
        var resultArr = [];
        _.forEach(arr, (element, index) => {
            var data = FATE_DATA_MANAGER.getFortuneLiuRiData(fateInfo, yueArr, element, index);
            // 当前流日
            data.current = element.y == nowTime[0] && element.m == nowTime[1] && element.d == nowTime[2] ? true : false;
            resultArr.push(data);
        });
        // console.log("getFortuneLiuRiDataByYear----", resultArr);
        return resultArr;
    },
    getFortuneLiuRiData(fateInfo, yueArr, data, index) {
        var resultData = {
            id: (data.d + (index + 1) * 100 + index),
            index: index,
            g: data.g,
            ganzhi: data.msg,
            type: 'liuri',
            monthday: [data.m, data.d],
            title: [(data.m + '-' + data.d)],
            key: yueArr[0].toString() + yueArr[1].toString() + data.d.toString() + data.m.toString(),
            gan: FORMAT.getTianGanWordDataByIndex(data.g),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', data.g, fateInfo.rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(data.z),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', data.z, fateInfo.rigan),
            nayin: NAYIN.getNaYinByGanZhi(data.g, data.z).split(''),
            nianKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[0]+''+fateInfo.dz[0], data.z) : false,
            riKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[2]+''+fateInfo.dz[2], data.z) : false,
            choosed: false
        }
        return resultData;
    },
    // 获取八字运盘:流时信息
    getFortuneLiuShiDataByYear(fateInfo, fateSideListData, shiTime) {
        var arr = PAIPAN.getLiuRISLiuShi(shiTime);
        var nowTime = MOMENT_TIME.getTimeArrayByTimeStamp();
        var isToday = fateSideListData[0].current && fateSideListData[1].current && fateSideListData[2].current && fateSideListData[3].current;
        var resultArr = [];
        _.forEach(arr, (element, index) => {
            var data = FATE_DATA_MANAGER.getFortuneLiuShiData(fateInfo, shiTime, element, index);
            data.current = isToday && element.beg <= nowTime[3] && nowTime[3] < element.end ? true : false;
            resultArr.push(data);
        })
        // console.log("getFortuneLiuShiDataByYear----", resultArr);
        return resultArr;
    },
    getFortuneLiuShiData(fateInfo, shiTime, data, index) {
        var resultData = {
            id: (data.beg + data.end + (index + 1) * 100 + index),
            index: index,
            ganzhi: data.msg,
            type: 'liushi',
            title: [(data.beg + '-' + data.end)],
            key: shiTime.toString() + data.beg.toString() + data.end.toString(),
            gan: FORMAT.getTianGanWordDataByIndex(data.g),
            ganCang: FORMAT.getHideArrDataByIndex('tiangan', data.g, fateInfo.rigan),
            zhi: FORMAT.getDiZhiWordDataByIndex(data.z),
            zhiCang: FORMAT.getHideArrDataByIndex('dizhi', data.z, fateInfo.rigan),
            nayin: NAYIN.getNaYinByGanZhi(data.g, data.z).split(''),
            nianKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[0]+''+fateInfo.dz[0], data.z) : false,
            riKong: fateInfo.tg ? KONGWANG.getNianKongByNianRiZhu(fateInfo.tg[2]+''+fateInfo.dz[2], data.z) : false,
        }
        return resultData;
    },
    // 八字命盘:右边栏的数据:添加数据
    addFateSideData(subTitle, origiData, addData) {
        var resultData = origiData, tempData;
        tempData = addData;
        switch (tempData.type) {
            case "dayun":
                // tempData.title = ["大运"].concat(tempData.title);
                // tempData.current = false;
                subTitle = subTitle + (tempData.ganzhi + "大运");
                break;
            case "liunian":
                // tempData.title = ["流年"].concat(tempData.title);
                subTitle = subTitle + (' > ' + tempData.ganzhi + "流年");
                break;
            case "liuyue":
                // tempData.title = ["流月"].concat(tempData.title);
                subTitle = subTitle + (' > ' + tempData.ganzhi + "流月");
                break;
            case "liuri":
                // tempData.title = ["流日"].concat(tempData.title);
                subTitle = subTitle + (' > ' + tempData.ganzhi + "流日");
                break;
            default:
                break;
        }
        resultData.push(tempData);
        var result = {
            "title": subTitle,
            "data": resultData
        }
        // console.log("addFateSideData------", result.title, result.data)
        return result;

    },
    // 八字命盘:右边栏的数据:修改数据
    updateFateSideData(subTitle, origiData, newData) {
        // console.log('updateFateSideData-----', subTitle, origiData, newData)
        var resultData = origiData, tempData = Object.assign(newData);
        switch(tempData.type){
            case 'dayun':
                resultData.splice(0, 1);
                resultData[0] = tempData;
                subTitle = tempData.ganzhi + "大运";
                break;
            case 'liunian':
                resultData.splice(1, 1);
                resultData[1] = tempData;
                subTitle = subTitle.slice(0, 7) + tempData.ganzhi + "流年";
                break;
            case 'liuyue':
                resultData.splice(2, 1);
                resultData[2] = tempData;
                subTitle = subTitle.slice(0, 14) + tempData.ganzhi + "流月";
                break;
            case 'liuri':
                resultData.splice(3, 1);
                resultData[3] = tempData;
                subTitle = subTitle.slice(0, 21) + tempData.ganzhi + "流日";
                break;
            default:
                break;
        }
        var result = {
            "title": subTitle,
            "data": resultData
        }
        return result;
    },
    // 八字命盘:右边栏的数据:删除数据
    deleteFateSideData(subTitle, origiData, deleteData) {
        var resultData = origiData, tempData, showType;
        tempData = deleteData;
        showType = tempData.type;
        switch (tempData.type) {
            case "dayun":
                resultData = [];
                subTitle = "";
                break;
            case "liunian":
                resultData.splice(1, resultData.length - 1);
                subTitle = subTitle.slice(0, (subTitle.indexOf("流年") - 5));
                break;
            case "liuyue":
                resultData.splice(2, resultData.length - 1);
                subTitle = subTitle.slice(0, (subTitle.indexOf("流月") - 5));
                break;
            case "liuri":
                resultData.splice(3, resultData.length - 1);
                subTitle = subTitle.slice(0, (subTitle.indexOf("流日") - 5));
                break;
            default:
                break;
        }
        var result = {
            "type": showType,
            "title": subTitle,
            "data": resultData
        }
        // console.log("deleteFateSideData------", resultData, result)
        return result;
    },
    getTodayFateSideListData(fateInfo, fortuneListData) {
        var today = MOMENT_TIME.getTimeArrayByTimeStamp(),
            todayStamp = MOMENT_TIME.getTimeStampByNow(),
            lunarTime = PAIPAN.Solar2Lunar(today[0], today[1], today[2]);
        var from = 'detail', dayunData, liunianData, liuyueData, liuriData, resultList = [];
        // 处理当前大运
        _.forEach(fortuneListData, element => {
            dayunData = element.year <= lunarTime.y && lunarTime.y <= element.year+9 ? element : dayunData;
        });
        if(!dayunData) { return resultList };
        dayunData.current = true;
        resultList.push(dayunData);
        
        // 处理当前流年
        var liunianList = FATE_DATA_MANAGER.getFortuneLiuNianDataByYear(fateInfo, {
            startAge: parseInt(dayunData.title[1].slice(0, -1)), yearNum: parseInt(dayunData.year), dayunBefore: dayunData.before
        }, from);
        liunianData = liunianList.filter(el => {return el.current}) ? liunianList.filter(el => {return el.current})[0] : null;
        if(!liunianData) { return resultList };
        resultList.push(liunianData);

        // 处理当前流月
        var liuyueList = PAIPAN.getLiuYue(today[0]);
        _.forEach(liuyueList, (element, index) => {
            var temp1 = '', temp2 = '', month1, month2;
            // 当前月
            temp1 = UTILS.getYmdHmsTimeStrByArr([liuyueList[index].y, liuyueList[index].m, liuyueList[index].d]);
            month1 = MOMENT_TIME.getUnixTimeByTimeStr(temp1);
            // 下一月
            if(index < liuyueList.length-1) {
                temp2 = UTILS.getYmdHmsTimeStrByArr([liuyueList[index+1].y, liuyueList[index+1].m, liuyueList[index+1].d]);
            }else {
                var tempArr = PAIPAN.getLiuRi(liuyueList[index].begtime, liuyueList[index].endtime),
                    lastDay = tempArr && tempArr.length > 0 ? tempArr[tempArr.length-1] : undefined;
                temp2 = lastDay ?  UTILS.getYmdHmsTimeStrByArr([lastDay.y, lastDay.m, lastDay.d, 24]) : "";
            }
            // 最后一月
            month2 = MOMENT_TIME.getUnixTimeByTimeStr(temp2);
            liuyueData = month1 <= todayStamp && todayStamp <= month2 ? FATE_DATA_MANAGER.getFortuneLiuYueData(fateInfo, element, index, from) : liuyueData;
        });
        if(!liuyueData) { return resultList };
        liuyueData.current = true;
        resultList.push(liuyueData);

        // 处理当前流日
        var liuriList = PAIPAN.getLiuRi(liuyueData.time[0], liuyueData.time[1]);
        _.forEach(liuriList, (element, index) => {
            liuriData = element.y == today[0] && element.m == today[1] && element.d == today[2] ? FATE_DATA_MANAGER.getFortuneLiuRiData(fateInfo, liuyueData.time, element, index) : liuriData;
        });
        if(!liuriData) { return resultList };
        liuriData.current = true;
        resultList.push(liuriData);
        return resultList;
    },
    // 八字运盘:更新列表元素的当前选中状态
    updateFortuneListDataChoosed(origiData, newData) {
        var curIndex = UTILS.getIdIndexInObjectArray(origiData, newData.id);
        origiData.forEach((data, index) => {
            data.choosed = false;
            if(index == curIndex) {
                data.choosed = true;
            }
        });
        return origiData;
    },
    // 重置选中状态
    resetListDataChoosed(origiData) {
        origiData.forEach(data => {
            data.choosed = false;
        });
        return origiData;
    },
    // 迷你运盘:根据年份获取Data数据:大运or流年
    getFortuneItemDataByYear(origiData, year) {
        for(var data of origiData) {
            if(data.year == year){
                return data
            }
        }
        return null;
    },
    // 四柱起盘:获取当前时间的八字
    getCurrentEightWordArr(formData) {
        var sex = formData && formData.sex != '' ? parseInt(formData.sex) : 0,
            zwzs = formData && formData.zwzs != '' ? parseInt(formData.zwzs) : 1, 
            time = formData && formData.birthday ? formData.birthday : MOMENT_TIME.getTimeStampByNow();
        var baziData = PAIPAN.GetInfo(sex, time, zwzs);
        var eightWordArr = FORMAT.getSiZhuEightWordArr(baziData);
        // console.log('getCurrentEightWordArr----', sex, zwzs, time, baziData, eightWordArr)
        return eightWordArr;
    },
    // 四柱起盘:获取与当前八字四柱相同的时间列表
    getSameEightWordList(eightWordArr) {
        var start = consts.CONST_START_END_YEAR[0], end = consts.CONST_START_END_YEAR[1], tg = [], dz = [];
        for(var arr of eightWordArr) {
            tg.push(FORMAT.getTianGanIndexByText(arr[0].text));
            dz.push(FORMAT.getDiZhiIndexByText(arr[1].text));
        }
        var resultList = [], sameGanZhiList = PAIPAN.GetSameGanZhiList(tg, dz, start, end);
        for(var list of sameGanZhiList) {
            var y = parseInt(list.y), 
                m = list.m < 10 ? '0' + list.m : list.m, 
                d = list.d < 10 ? '0' + list.d : list.d, 
                h = list.h < 10 ? '0' + list.h : list.h,
                mi = list.i < 10 ? '0' + list.i : list.i,
                s = list.s < 10 ? '0' + list.s : list.s;
            var solarTime = PAIPAN.Solar2Lunar(parseInt(y), parseInt(m), parseInt(d));
            var runStr = solarTime.r == 1 ? "闰" : "";
            var data = {
                text_one: y + '年' + m + '月' + d + '日 ' + h + ':' + mi,
                text_two: '农历: ' + FORMAT.getChineseWordByNumber('year', solarTime.y) + runStr + FORMAT.getChineseWordByNumber('month', solarTime.m) + FORMAT.getChineseWordByNumber('day', solarTime.d) + ' ' + FORMAT.getShiChenByNumber(parseInt(h)),
                chaodai: y >= 1949 ? '' : PAIPAN.GetNianHao(y), // 当代的不显示朝代年号这些信息
                selected: sameGanZhiList.indexOf(list) == 0 ? true : false,
                birthday: MOMENT_TIME.getUnixTimeByTimeStr(UTILS.formatYearNum(y) + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s)
            }
            resultList.push(data);
        }
        // console.log('getSameEightWordList----', eightWordArr, tg, dz, sameGanZhiList, resultList)
        return resultList;
    },
    // 四柱起盘:修改八字四柱列表数据，并更新与更新后的八字四柱相同的时间列表
    updateEightWordArrByData(origiList, pos, newData) {
        // 更新八字数据
        if(origiList[pos[0]][pos[1]]) {
            origiList[pos[0]][pos[1]] = Object.assign({}, newData);
        }
        return origiList;
    },
    // 命盘页:获取神煞
    getDetailShenShaListByList(fateList, allList){
        console.log('getShenShaListByList------', fateList, allList);
        var fateSiZhu = [], allZhu = [];
        fateList.forEach(data => {
            fateSiZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        allList.forEach(data => { 
            allZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        var resultList = SHEN_SHA.getAllListShenSha(fateSiZhu, allZhu);
        return resultList;
    },
    // 命盘页:获取合化冲关系
    getDetailRealationListByList(fateList, allList){
        var fateSiZhu = [], allZhu = [];
        fateList.forEach(data => {
            fateSiZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        allList.forEach(data => { 
            allZhu.push(data.ganzhi != '不详' ? data.ganzhi : '') 
        })
        var resultList = HE_HUA_CHONG.getAllListHeHuaChong(allZhu);
        return resultList;
    },
    // 获取**生在**月的文本
    getFateTextByData(data) {
        var rigan = FORMAT.getTianGanByIndex(data.tg_3) + WUXING.getWuXingByIndex(WUXING.getTianGanXingByIndex(data.tg_3)),
            yuezhi = FORMAT.getDiZhiByIndex(data.dz_2) + WUXING.getWuXingByIndex(WUXING.getDiZhiXingByIndex(data.dz_2));
        return rigan + '生在' + yuezhi + '月';
    },
    // 获取前一个数据
    getPreviousDataInList(listData, curData) {
        var resultData = [], len = listData.length;
        for(var i = 0; i < len; i++) {
            if(listData[i].id == curData.id) {
                resultData = i > 0 ? listData[i-1] : listData[0];
                return resultData;
            }
        }
        return resultData;
    },
    // 获取后一个数据
    getNextDataInList(listData, curData) {
        var resultData = [], 
            len = curData.type == 'dayun' ? 10 : listData.length;
        for(var i = 0; i < len; i++) {
            if(listData[i].id == curData.id) {
                resultData = i < len-1 ? listData[i+1] : listData[len-1];
                return resultData;
            }
        }
        return resultData;
    },
    getFortuneItemDataByLiunian(listData, liunian) {
        for(var i = 0; i < listData.length; i++) {
            if(parseInt(listData[i].year) <= parseInt(liunian) && parseInt(listData[i].year) + 10 > parseInt(liunian)) {
                return listData[i];
            }
        }
        return null;
    },
    getFortuneItemDataByItemId(listData, dataId) {
        for(var i = 0; i < listData.length; i++) {
            if(listData[i].year == dataId) {
                return listData[i];
            }
        }
        return null;
    },
    // 获取当前时间的八字列表数据
    getCurrentTimeFateListData(detailInfo) {
        var sex = detailInfo ? detailInfo.sex : 0,
            curTime = detailInfo ? detailInfo.birthday : MOMENT_TIME.getTimeStampByNow(),
            zwzs = detailInfo ? detailInfo.zwzs : 1,
            baziData = PAIPAN.GetInfo(sex, curTime, zwzs), from = 'detail', fateSideListData = [];
        var fateListData = FATE_DATA_MANAGER.getFateListDataByData(0, baziData, curTime, from);
        var dayunData = FATE_DATA_MANAGER.getFortuneDaYunData(baziData.big_info[0], 0, baziData.tg[2], from, baziData.tg, baziData.dz),
            fateInfo = {tg: baziData.tg, dz: baziData.dz, rigan: baziData.tg[2]};
            fateSideListData.push(dayunData);
        var liunianArr = PAIPAN.getLiuNian(dayunData.year), startAge = parseInt(dayunData.title[1].slice(0, -1)),
            liunianData = FATE_DATA_MANAGER.getFortuneLiuNianData(fateInfo, liunianArr[0], 0, startAge, from);
            fateSideListData.push(liunianData);
        var liuyueArr = PAIPAN.getLiuYue(liunianData.year),
            liuyueData = FATE_DATA_MANAGER.getFortuneLiuYueData(fateInfo, liuyueArr[0], 0, from);
            fateSideListData.push(liuyueData);
        var liuriArr = PAIPAN.getLiuRi(liuyueData.time[0], liuyueData.time[1]),
            liuriData = FATE_DATA_MANAGER.getFortuneLiuRiData(fateInfo, liuyueData.time, liuriArr[0], 0);
            fateSideListData.push(liuriData);
        return {
            fateListData: fateListData,
            fateSideListData: fateSideListData
        }
    }
}

export {
    FATE_DATA_MANAGER
}